/**
 * Supported content languages for the onboarding language picker.
 *
 * Derived from the generated `LanguageEnum` — which orval generates from the
 * API's OpenAPI spec, itself built from the backend list
 * (app/Support/Languages.php). The backend is the single source of truth and
 * this list can never drift from it: regenerating the client is the only way to
 * change it. Because the language value and its display label are the same
 * (the name), the enum carries everything the picker needs.
 */

import { LanguageEnum } from '../api/generated/insights.schemas';

export type LanguageOption = {
  value: LanguageEnum;
  label: string;
  disabled?: boolean;
};

// The value and label are both the language name. Enum order (most common
// business/content languages first, then alphabetical) is preserved.
export const commonLanguageOptions: LanguageOption[] = Object.values(
  LanguageEnum,
).map((name) => ({ value: name, label: name }));

export const commonLanguageOptionsFlat = commonLanguageOptions;
